/* eslint-disable camelcase */
import React from "react";
import inPersonImg from 'src/assets/icons/icon-inPerson.svg';
import teletherapyImg from 'src/assets/icons/icon-teletherapy.svg';
import acceptingClientsImg from 'src/assets/icons/icon-takingNewClients.svg';
import notAcceptingClientsImg from 'src/assets/icons/icon-NotTakingNewClients.svg';
import { Typography } from "src/latest/src/components";

interface Choice {
    unique_key: string;
    selected: string;
    display_title: string;
}

interface Props {
    isPracticeProfilePage: boolean;
    choices: Choice[];
}

const PathEnum = {
    ONLY_ONLINE: 'onlyOnlineSessionsChoiceV1',
    ONLY_IN_PERSON: 'onlyInPersonSessionsChoiceV1',
    ACCEPTING_CLIENTS: 'acceptingNewClientChoice',
    NOT_ACCEPTING_CLIENTS: 'notAcceptingNewClientChoice',
    EITHER_TELETHERAPY_OR_IN_PERSON_SESSIONS: "eitherTeletherapyOrInPersonSessionsChoiceV1",
};

export const MeetingPreferenceOption: React.FC<Props> = ({ isPracticeProfilePage, choices }) => {
    return (
        <>
            {choices?.map((choice, index) => {
                const uniquekey = choice.unique_key;

                if (choice?.selected || isPracticeProfilePage) {
                    const isMultiple = uniquekey === PathEnum.EITHER_TELETHERAPY_OR_IN_PERSON_SESSIONS;
                    let singleImage: { img?: string; imgBG?: string } = {};

                    if (uniquekey === PathEnum.ONLY_ONLINE) {
                        singleImage = { img: teletherapyImg, imgBG: 'mf-tele' };
                    } else if (uniquekey === PathEnum.ONLY_IN_PERSON) {
                        singleImage = { img: inPersonImg, imgBG: 'mf-in-person' };
                    } else if (uniquekey === PathEnum.ACCEPTING_CLIENTS) {
                        singleImage = { img: acceptingClientsImg, imgBG: 'mf-accepting-clients' };
                    } else if (uniquekey === PathEnum.NOT_ACCEPTING_CLIENTS) {
                        singleImage = { img: notAcceptingClientsImg, imgBG: 'mf-not-accepting-clients' };
                    }

                    const singleImgClass = "therapist-profile__meeting-pref practice-profile__meeting-pref mf " + singleImage.imgBG;

                    return (
                        <div key={'meetingpreference-' + index} className=' practice-profile__meeting-pref-wrap  therapist-profile__meeting-pref-wrap'>
                            {isMultiple ?
                                (
                                    <div className='multiple-meet-pref'>
                                        <label className='therapist-profile__meeting-pref  practice-profile__meeting-pref mf mf-tele'>
                                            <img src={teletherapyImg} alt='Teletherapy' />
                                        </label>
                                        <label className='therapist-profile__meeting-pref practice-profile__meeting-pref mf mf-in-person'>
                                            <img src={inPersonImg} alt='In Person' />
                                        </label>
                                    </div>
                                ) : (
                                    <label
                                        className={singleImgClass}>
                                        <img src={singleImage.img} alt={choice.display_title} />
                                    </label>
                                )
                            }
                            <Typography variant='size-16' weight='normal'
                                color='color-2' className='d-inline-block meet-pref-text'>{choice.display_title}</Typography>
                        </div>
                    );
                }

                return null;
            })}
        </>
    );
};


